class @App.Components.Toggle
  constructor: ->
    $(document).on 'change', '[data-submit-on-change]', (e) ->
      e.preventDefault()
      $el = $(@)
      $el.trigger('submit.rails')

$ ->
  new App.Components.Toggle
